import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { createModal } from '../../components/generic/Modal';
import { useParticipantNotesQuery } from '../../graphql/hooks/useParticipantQuery';
import { useAppContext } from '../../hooks/useAppContext';
import { ParticipantNoteEditor } from './ParticipantNoteEditor';

interface Props {
  participantNoteId: string;
  participantId: string;
  isDisabled?: boolean;
}

export const ParticipantNoteEditModal = createModal<Props>((props) => {
  const { participantId, participantNoteId, isDisabled, modal } = props;

  const { queryClient, organization } = useAppContext();
  const { remove, hide, visible } = modal;

  const onClose = React.useCallback(() => {
    // Close modal, and invalidate the notes after 1s.
    // Enough time for hocus to save. I don't have a better way of doing this right now
    hide();
    setTimeout(() => {
      queryClient.invalidateQueries(
        useParticipantNotesQuery.getKey({
          organizationId: organization.id,
          participantId,
        }),
      );
    }, 2000);
  }, [hide, organization.id, participantId, queryClient]);

  return (
    <ChakraV3.Dialog.Root
      open={visible}
      onOpenChange={hide}
      onExitComplete={remove}
      size='cover'
      scrollBehavior='inside'
    >
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.DialogTitleSubtitle
            title='Edit a note'
            subtitle='Please complete the following to proceed'
          />
          <ChakraV3.Dialog.Body px={0}>
            <ParticipantNoteEditor
              participantId={participantId}
              participantNoteId={participantNoteId}
              isDisabled={isDisabled}
              onDelete={onClose}
            />
          </ChakraV3.Dialog.Body>
          <ChakraV3.Dialog.Footer>
            <ChakraV3.Button onClick={hide} size='sm' variant='subtle'>
              Close
            </ChakraV3.Button>
          </ChakraV3.Dialog.Footer>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});
